<template>
  <div>
    <list-search-box v-model="form" @submit="doSearches" />
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" :row-class-name="tableRowClassName">
        <el-table-column prop="date" label="操作" width="130" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="godoIt(row)">
              办理
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="left" min-width="150" />
        <el-table-column prop="contractNum" label="合同编号" align="left" width="140" />
        <el-table-column prop="distributorName" label="代理商名称" align="left" min-width="150" />
        <el-table-column prop="contractType" label="订单分类" align="left" min-width="80" />
        <el-table-column label="现销/赊销" align="left" min-width="80">
          <template v-slot="{row}">
            <span v-if="row.salesType === 1">现销</span>
            <span v-else-if="row.salesType === 2">赊销</span>
            <span v-else-if="row.salesType === 3">LC</span>
          </template>
        </el-table-column>
        <el-table-column label="分配比例" align="right" header-align="left" min-width="70">
          <template v-slot="{row}">
            <span>
              {{ row.assignRatio }}%
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="salesManName" label="外销" align="left" min-width="60" />
        <el-table-column prop="createTime" label="合同时间" align="left" min-width="90" />
        <el-table-column prop="date" label="合同附件" width="80" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="showFile(row)">
              操作
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
      <contract-file-dialog ref="fileDialog" />
    </div>
  </div>
</template>
<script type="es6">
import listSearchBox from './ListSearchBox';
import contractFileDialog from './ContractFileDialog';
import { getIntOrdersContractList } from '@/API/international.js';
export default {
  data () {
    return {
      form: {
        projectName: '',
        contractNum: '',
        distributorName: '',
        salesManName: '',
        createBeginTime: '',
        createEndTime: '',
        businessApproval: 1 // 1 未审核 2 已审核
      },
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },
  components: {
    listSearchBox,
    contractFileDialog
  },
  computed: {
  },
  methods: {
    doSearch (resolve) {
      this.tableLoading = true;
      getIntOrdersContractList({
        ...this.form,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        if (resolve) resolve();
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
          this.$emit('totalNumber', this.page.total);
        }
      }).catch(() => {
        if (resolve) resolve();
        this.tableLoading = false;
      });
    },
    doSearches (data, cab) {
      this.page.currentPage = 1;
      this.doSearch();
      cab(false);
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    showFile (row) {
      this.$refs.fileDialog.showFile(row.id);
    },
    godoIt (row) {
      this.$router.push({
        'name': 'businessHandler',
        params: {
          contractNum: row.contractNum,
          contractType: row.contractType
        },
        query: { isShowInternationalService: row.civilInternational }
      });
    },
    tableRowClassName ({ row }) {
      // if (row.salesType === 2) {
      //   return 'warning-row';
      // }
      // if (row.isHuaQiangFlag === 1) {
      //   return 'highlight-row';
      // }
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>
<style>
  .el-table .warning-row {
    color: red;
  }
  .el-table .highlight-row {
    color: #67C23A;
  }
</style>
